import { useMutation, useQuery, useQueryClient } from 'react-query'
import { AxiosError } from 'axios'
import {
  getJobsWithUndatedWebEntries,
  getUndatedWebEntries,
  JobWithUndatedWebEntries,
  saveUndatedWebEntryDates,
  SaveUndatedWebEntryDatesRequest,
  SaveUndatedWebEntryDatesResult,
  UndatedWebEntriesRequest,
  UndatedWebEntriesResult,
} from './undatedWebEntriesApi'

const undatedJobsKey = (tenantId: number | undefined) => {
  return ['admin', 'undated-web-entries', 'jobs', tenantId ?? 0]
}

const undatedEntriesKey = (request: UndatedWebEntriesRequest | null) => {
  return ['admin', 'undated-web-entries', 'items', request?.tenantId ?? 0, request?.jobId ?? 0]
}

export const useJobsWithUndatedWebEntriesQuery = (tenantId: number | undefined) => {
  return useQuery<JobWithUndatedWebEntries[], AxiosError>(undatedJobsKey(tenantId), {
    queryFn: () => getJobsWithUndatedWebEntries(tenantId as number),
    enabled: tenantId !== undefined,
    refetchOnWindowFocus: false,
  })
}

export const useUndatedWebEntriesQuery = (request: UndatedWebEntriesRequest | null) => {
  return useQuery<UndatedWebEntriesResult, AxiosError>(undatedEntriesKey(request), {
    queryFn: () => getUndatedWebEntries(request as UndatedWebEntriesRequest),
    enabled: request !== null,
    refetchOnWindowFocus: false,
    retry: false,
  })
}

export const useSaveUndatedWebEntryDatesMutation = () => {
  const queryClient = useQueryClient()
  return useMutation<SaveUndatedWebEntryDatesResult, AxiosError, SaveUndatedWebEntryDatesRequest>({
    mutationFn: (request: SaveUndatedWebEntryDatesRequest) => saveUndatedWebEntryDates(request),
    onSuccess: (_, request) => {
      queryClient.invalidateQueries(undatedEntriesKey(request))
      queryClient.invalidateQueries(undatedJobsKey(request.tenantId))
    },
  })
}
